import { Component, OnInit } from '@angular/core';
import { CurrentFacilityService } from 'src/app/shared/services';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
})
export class HeaderAllianceComponent implements OnInit {
    public administrativeLoginURL: string;
    public homeURL: string;
    public showFacilityInformation: boolean;
    public cartDisallowedRoutes: string[];

    constructor(private currentFacilityService: CurrentFacilityService) {
        this.homeURL = 'search-awb';
        this.showFacilityInformation = true;
        this.cartDisallowedRoutes = ['cart/confirmation'];
    }

    ngOnInit(): void {
        this.administrativeLoginURL = this.currentFacilityService.getUrlAdministrative();
    }
}
